import dayjs from 'dayjs';
import { ToastMessage } from '@lean-body/components/molecules/toast';
export const StreakToastMessageMap = {
    live_lesson_completion: ToastMessage.liveLesson,
    weight_entry: ToastMessage.weight,
    step_goal_completion: ToastMessage.stepGoal,
    workout_goal_achievement: ToastMessage.workoutGoal,
    meal_breakfast_completion: ToastMessage.breakfast,
    meal_lunch_completion: ToastMessage.lunch,
    meal_dinner_completion: ToastMessage.dinner,
    meal_snacking_completion: ToastMessage.snacking,
};
export const STREAK_FREEZE_STOCK_MAX = 2;
export class StreakCompletionResult {
    constructor(data, config) {
        var _a, _b, _c, _d, _e;
        Object.defineProperty(this, "isFirstDailyCompletion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isFirstStreakCompletion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isFreezeGranted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentStreak", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sourceType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "startDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "freezeUsedDates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "completionAnimationUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "completionMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "incrementAnimationUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "incrementMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.isFirstDailyCompletion = data.isFirstDailyCompletion;
        this.isFirstStreakCompletion = data.isFirstStreakCompletion;
        this.isFreezeGranted = data.isFreezeGranted;
        this.currentStreak = data.currentStreak;
        this.sourceType = data.sourceType;
        this.startDate = dayjs(data.startDate);
        this.freezeUsedDates = (_a = data.freezeUsedDates) !== null && _a !== void 0 ? _a : [];
        this.completionAnimationUrl = (_b = data.completionAnimationUrl) !== null && _b !== void 0 ? _b : null;
        this.completionMessage = (_c = data.completionMessage) !== null && _c !== void 0 ? _c : null;
        this.incrementAnimationUrl = (_d = data.incrementAnimationUrl) !== null && _d !== void 0 ? _d : null;
        this.incrementMessage = (_e = data.incrementMessage) !== null && _e !== void 0 ? _e : null;
        this.config = config;
    }
    get resolvedIncrementAnimationUrl() {
        const url = this.incrementAnimationUrl;
        if (!url)
            return null;
        if (!url.startsWith('/streak/') || !url.endsWith('.json'))
            return null;
        return `${this.config.cdnBaseURL}${url}`;
    }
    getBaseDateFromStartDate() {
        const today = dayjs();
        const targetDayOfWeek = this.startDate.day();
        const candidate = today.day(targetDayOfWeek);
        if (candidate.isAfter(today)) {
            return candidate.subtract(7, 'day');
        }
        return candidate;
    }
}
export class CurrentStreak {
    constructor(data) {
        Object.defineProperty(this, "streakCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isFirstDailyCompletion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isUsedFreezeYesterday", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.streakCount = data.streakCount;
        this.isFirstDailyCompletion = data.isFirstDailyCompletion;
        this.isUsedFreezeYesterday = data.isUsedFreezeYesterday;
    }
    get hasStreak() {
        return this.streakCount > 0;
    }
}
export class Streak {
    constructor(data) {
        Object.defineProperty(this, "streakCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isFirstDailyCompletion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isUsedFreezeYesterday", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "streakDates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "freezeUsedDates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "freezeStock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.streakCount = data.streakCount;
        this.isFirstDailyCompletion = data.isFirstDailyCompletion;
        this.isUsedFreezeYesterday = data.isUsedFreezeYesterday;
        this.streakDates = data.streakDates;
        this.freezeUsedDates = data.freezeUsedDates;
        this.freezeStock = data.freezeStock;
    }
}
export class StreakCompletionSummaryDay {
    constructor(data) {
        Object.defineProperty(this, "date", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lessonCompletion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lessonKcal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lessonMinutes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "watchedLiveLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mealInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mealBreakfastInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mealLunchInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mealDinnerInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mealSnackingInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "workoutCompletion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "walkingCompletion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "weightInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "freezeUsed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.date = dayjs(data.date);
        this.lessonCompletion = data.lessonCompletion;
        this.lessonKcal = data.lessonKcal;
        this.lessonMinutes = data.lessonMinutes;
        this.watchedLiveLesson = data.watchedLiveLesson;
        this.mealInput = data.mealInput;
        this.mealBreakfastInput = data.mealBreakfastInput;
        this.mealLunchInput = data.mealLunchInput;
        this.mealDinnerInput = data.mealDinnerInput;
        this.mealSnackingInput = data.mealSnackingInput;
        this.workoutCompletion = data.workoutCompletion;
        this.walkingCompletion = data.walkingCompletion;
        this.weightInput = data.weightInput;
        this.freezeUsed = data.freezeUsed;
    }
    get hasCompletion() {
        return (this.lessonCompletion ||
            this.watchedLiveLesson ||
            this.mealInput ||
            this.mealBreakfastInput ||
            this.mealLunchInput ||
            this.mealDinnerInput ||
            this.mealSnackingInput ||
            this.workoutCompletion ||
            this.walkingCompletion ||
            this.weightInput);
    }
    get dateString() {
        return this.date.format('YYYY-MM-DD');
    }
}
export class StreakCompletionSummary {
    constructor(data) {
        Object.defineProperty(this, "isFirstDailyCompletion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isUsedFreezeYesterday", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentStreak", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "days", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalCompletedDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalFreezeUsedDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "freezeStock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.isFirstDailyCompletion = data.isFirstDailyCompletion;
        this.isUsedFreezeYesterday = data.isUsedFreezeYesterday;
        this.currentStreak = data.currentStreak;
        this.days = data.days.map((day) => new StreakCompletionSummaryDay(day));
        this.totalCompletedDays = data.totalCompletedDays;
        this.totalFreezeUsedDays = data.totalFreezeUsedDays;
        this.freezeStock = data.freezeStock;
    }
    get completedDates() {
        return this.days.filter((day) => day.hasCompletion && day.date.isValid()).map((day) => day.dateString);
    }
    get freezeUsedDates() {
        return this.days.filter((day) => day.freezeUsed).map((day) => day.dateString);
    }
    toStreak() {
        return new Streak({
            streakCount: this.currentStreak,
            isFirstDailyCompletion: this.isFirstDailyCompletion,
            isUsedFreezeYesterday: this.isUsedFreezeYesterday,
            streakDates: this.completedDates,
            freezeUsedDates: this.freezeUsedDates,
            freezeStock: this.freezeStock,
        });
    }
}
